export const AGENDA_VISIT_DIALOG_RESCHEDULE_CLICKED_ANALYTICS =
  'agentsPwa/Agenda/VisitDetail/AGENDA_VISIT_DIALOG_RESCHEDULE_CLICKED_ANALYTICS';
export const AGENDA_VISIT_CANCELLATION_CONTINUE_CLICKED =
  'agentsPwa/Agenda/Dialog/AGENDA_VISIT_CANCELLATION_CONTINUE_CLICKED';
